export default __webpack_public_path__ + "static/media/bg-value-Economies.9e0db7f9.jpg";